// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"424":"0cdd2cda","437":"75fd8aa6","552":"594966c1"}[chunkId] + ".chunk.css";
};